<template>
  <select class="klickart-select">
    <option value="" selected>{{ $t('edit.sidebar.go_to_next') }}</option>
    <option
      v-for="step in stepInactiveList"
      :value="step.id"
      :selected="step.id === selected">{{ `${stepDisplayPosition(step)} - ${step.sanitized_title}` }}</option>
  </select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import $ from 'jquery';
import 'select2';

export default {
  props: [
    'jump',
    'selected',
  ],
  mounted() {
    const templateResult = step => {
      const className = step.alreadyUsed ? 'step-already-used' : '';

      return $(`<span class="${className}">${step.text}</span>`);
    };

    $(this.$el)
      .val(this.selected)
      .select2({
        data: this.stepJumpSelectOptions,
        templateResult,
      })
      .on('change', event => {
        this.$store.dispatch('jumpUpdateDestinationStepId', { jump: this.jump, event });
      });
  },
  computed: mapGetters({
    jumpList: 'jumpList',
    stepInactiveList: 'stepInactiveList',
    stepDisplayPosition: 'stepDisplayPosition',
    stepJumpSelectOptions: 'stepJumpSelectOptions',
  }),
  methods: mapActions([
    'jumpUpdateDestinationStepId',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** StepJumpSelect.vue?56f8c78d
 **/